import { render } from "./CreateVMFromBackup.vue?vue&type=template&id=3e2348b1&scoped=true"
import script from "./CreateVMFromBackup.vue?vue&type=script&lang=js"
export * from "./CreateVMFromBackup.vue?vue&type=script&lang=js"

import "./CreateVMFromBackup.vue?vue&type=style&index=0&id=3e2348b1&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2348b1"]])

export default __exports__